<template>
  <div style="height: 100vh;background-color: #ffffff;">
    <div class="navbar nav-main w-100" style="background-color:#23409A;color:white">
      <h6 class="w-100 text-center my-3">ยกเลิกบริการลงทะเบียนใช้งาน Next Connect</h6>
    </div>
    <div class="my-8   flex-all-center">
      <div class="session-with-nav">
        <v-img class="my-5 radius-circle" style="width:60vw;height:auto" src="@/assets/unlink.png"></v-img>
      </div>
    </div>
    <h5 class="text-center mb-8" style="color:red">ยกเลิกบริการสำเร็จ</h5>
    <div class="flex-all-center mt-8">
      <v-btn @click="close" class=" px-8 main-btn col-8" style="color:white;background: radial-gradient(129.77% 129.77% at 48.82% -19.51%, #AEAEAE 0%, #959595 32.18%, #8B8B8B 60.19%, #838383 71.88%, #817F7F 95.35%);box-shadow: 16px 8px 18px #D6D6D6, inset 14px 12px 13px -4px rgba(255, 255, 255, 0.23);" color="#FD4337">กลับสู่แชท</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  computed: {
    idcard() {
      return this.$store.state.regisData.idcard;
    },
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
    input() {
      return this.$store.state.regisData ? this.$store.state.regisData : null;
    },
  },
  methods: {
    close() {
      this.$liff.closeWindow();
    },
  },
};
</script>

<style></style>
